// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"118": "lib-router","72": "lib-axios",}[chunkId] || chunkId) + "." + {"118": "fb7a0e51","208": "6d18274c","366": "c7d8f862","370": "2ae36991","489": "de9e83a7","51": "7e364de1","72": "ca34d5ce",}[chunkId] + ".js"
}